const {
  staticDataFolderName,
  contentfulConstant,
  bazaarVoiceFileName,
  urlBuilderFileName,
  productsFileName,
  articlesFileName
} = require('../../constants/global');
const {
  getContentfulQueryData,
} = require('../../services/contentful-graphql-api');

const productsByLocale = {
  'pt-BR': require('../../data/pt-BR/products.json'),
};

const articlesByLocale = {
  'pt-BR': require('../../data/pt-BR/articles.json'),
};

export default async (dataSource, pageType, locale, filters = null, isLoadExtraPDP = false) => {
  switch (dataSource) {
    case contentfulConstant:
      const data = await getContentfulQueryData(pageType, locale, filters, isLoadExtraPDP);
      return data;
    case bazaarVoiceFileName:
      let { default: allBvData } = await import(
        `../../${staticDataFolderName}/${locale}/${bazaarVoiceFileName}.json`
      );
      if (!filters) {
        return allBvData;
      }
      const bvData = allBvData.find(
        node =>
          node.productId === filters.ratingAndReviewId ||
          node.Id === filters.ratingAndReviewId
      );
      return bvData;
    case urlBuilderFileName:
      let { default: urlBuilderData } = await import(
        `../../${staticDataFolderName}/${locale}/${urlBuilderFileName}.json`
      );
      return urlBuilderData;
    case productsFileName:
      const productsData = productsByLocale[locale] || [];
      return productsData;
    case articlesFileName:
       return articlesByLocale[locale] || [];
    default:
      return null;
  }
};
